import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.couponInvalid)?_c(VAlert,{attrs:{"type":"error","close-label":"cerrar"},scopedSlots:_vm._u([{key:"close",fn:function(){return [_c(VBtn,{attrs:{"icon":""},on:{"click":_vm.closeInvalid}},[_c(VIcon,[_vm._v("close")])],1)]},proxy:true}],null,false,3221801398)},[_c('span',[_vm._v("Cupón Invalido")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }